import {triggersApi} from 'sources/api';
import cancelIfSending from 'sources/cancelIfSending';

const SearchFieldSource = cancelIfSending({
  fetchSearchFields() {
    return triggersApi.getJson('/account/searchFields').then(response => response);
  },
});

export default SearchFieldSource;
